import monstera from '../assets/monstera.jpg'
import lyrata from '../assets/lyrata.jpg'
import pothos from '../assets/pothos.jpg'
import succulent from '../assets/succulent.jpg'
import olivier from '../assets/olivier.jpg'
import basil from '../assets/basil.jpg'
import mint from '../assets/mint.jpg'
import calathea from '../assets/calathea.jpg'
import cactus from '../assets/cactus.jpg'
import aloe_vera from '../assets/aloe_vera.jpg'
import rebutia_krainziana from '../assets/rebutia_krainziana.jpg'
import kalanchoe from '../assets/kalanchoe.jpg'
import pilea from '../assets/pilea.jpg'
import romarin from '../assets/romarin.jpg'
import caoutchouc from '../assets/caoutchouc.jpg'

export const plantList = [
	{
		name: 'monstera',
		category: 'intérieur',
		id: '1ed',
		light: 2,
		water: 3,
		cover: monstera,
		price: 15
	},
	{
		name: 'ficus lyrata',
		category: 'intérieur',
		id: '2ab',
		light: 3,
		water: 1,
		cover: lyrata,
		price: 16
	},
	{
		name: 'pothos argenté',
		category: 'intérieur',
		id: '3sd',
		light: 1,
		water: 2,
		cover: pothos,

		price: 9
	},
	{
		name: 'calathea',
		category: 'intérieur',
		id: '4kk',
		light: 2,
		water: 3,
		cover: calathea,

		price: 20
	},
	{
		name: 'olivier',
		category: 'extérieur',
		id: '5pl',
		light: 3,
		water: 1,
		cover: olivier,
		price: 25
	},
	{
		name: 'cactus',
		category: 'plante grasse',
		id: '8fp',
		light: 2,
		water: 1,
		cover: cactus,
		price: 6
	},
	{
		name: 'basilique',
		category: 'extérieur',
		id: '7ie',
		light: 2,
		water: 3,
		cover: basil,
		price: 5
	},
	{
		name: 'succulente',
		category: 'plante grasse',
		id: '9vn',
		light: 2,
		water: 1,
		cover: succulent,
		price: 8
	},
	{
		name: 'menthe',
		category: 'extérieur',
		id: '6uo',
		light: 2,
		water: 2,
		cover: mint,
		price: 4
	},
	{
		name: 'aloe vera',
		category: 'plante grasse',
		id: '9om',
		light: 2,
		water: 1,
		cover: aloe_vera,
		price: 7
	},
	{
		name: 'cactus rebutia',
		category: 'plante grasse',
		id: '5ur',
		light: 3,
		water: 1,
		cover: rebutia_krainziana,
		price: 6
	},
	{
		name: 'kalanchoe',
		category: 'plante grasse',
		id: '4oi',
		light: 2,
		water: 1,
		cover: kalanchoe,
		price: 5
	},
	{
		name: 'pilea',
		category: 'intérieur',
		id: '6ty',
		light: 3,
		water: 2,
		cover: pilea,
		price: 9
	},
	{
		name: 'romarin',
		category: 'extérieur',
		id: '8ok',
		light: 3,
		water: 1,
		cover: romarin,
		price: 6
	},
	{
		name: 'caoutchouc',
		category: 'intérieur',
		id: '4yu',
		light: 1,
		water: 2,
		cover: caoutchouc,
		price: 12
	}
]